import React,{useState} from "react";
import {
  FormDataConsumer,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  required,
  BooleanInput,
  DateInput
} from "react-admin";
import VideoUpload from "../upload/FileUploader";
import { FormToolbar } from "../../common/FormToolbar";
import { useStyles } from "../../formStyles";
import moment from "moment";
export const DsrCreate = (props) => {
  const classes = useStyles({});
  const [isHospitalMaster, setHospitalMaster] = useState<boolean>(false);
  const [isProposalsend, setProposalsend] = useState<boolean>(false);
  let defaultValues = {
    
    date: moment().toISOString(),
    isExistingHosp: false,
    existingHospitalId: 0,
    hospitalName: "",
    isProposalsend:false,
    conveyance:0,
    approvedConveyance:0,
    isActive:true,
    hospitalAddress:""
    
  };

  return (
    <Create title="DSR Edit" {...props}>
      <SimpleForm initialValues={defaultValues} redirect="list" toolbar={<FormToolbar {...props} showDelete={false} />} variant="outlined" >
      <DateInput validate={[required()]} source="date" label="Date" formClassName={classes.one_three_input} />
       <BooleanInput validate={[required()]} source="isExistingHosp" label="Existing Hospital?" formClassName={classes.two_three_input}  onChange={(v) => {  setHospitalMaster(v); }}/> 
        {
          isHospitalMaster===true? 
          <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }} validate={[required()]} 
          filterToQuery={searchText => ({ 'name~like': searchText })}
          label="Hospital Name" source="existingHospitalId" reference="hospitals" fullWidth={true} formClassName={classes.last_three_input}>
          <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
        </ReferenceInput>: <TextInput validate={[required()]} source="hospitalName" label="Hospital"  formClassName={classes.last_three_input}  variant="outlined"/>

          // <ReferenceInput label="Hospital" source="existingHospitalId" reference="hospitals"   formClassName={classes.last_three_input}  sort={{ field: 'name', order: 'ASC' }} >
          //                           <SelectInput optionText="name" validate={[required()]} variant="outlined"/>
          //                          </ReferenceInput>: <TextInput validate={[required()]} source="hospitalName" label="Hospital"  formClassName={classes.last_three_input}  variant="outlined"/>
        }
      
         <TextInput   multiline={true} source="hospitalAddress" label="Hospital Address "   fullWidth={true} />
        
          <TextInput source="contactPersonName" label="Contact Person" fullWidth={true} formClassName={classes.one_three_input} />
          <TextInput source="contactNo" label="Contact No" fullWidth={true} formClassName={classes.two_three_input} />
          <TextInput source="emailId" label="Email" fullWidth={true} formClassName={classes.last_three_input} />

          <TextInput source="discussionDetails"   multiline={true} label="Discussion Details" fullWidth={true} formClassName={classes.first_inline_input} />
          <TextInput source="planofAction"   multiline={true} label="Plan Of Action" fullWidth={true} formClassName={classes.last_inline_input}/>

          <BooleanInput validate={[required()]} source="isProposalsend" label="Proposal Send?" fullWidth={true} formClassName={classes.one_three_input}  onChange={(v) => {  setProposalsend(v); }}/> 
          {isProposalsend===true
          ?
          <DateInput label="Proposal Send Date" source="proposalSendDate" fullWidth={true} formClassName={classes.two_three_input} />
          :<DateInput label="Proposal Send Date" disabled={true}  source="proposalSendDate"  fullWidth={true} formClassName={classes.two_three_input} />}
          
          <NumberInput validate={[required()]} source="conveyance" label="Conveyance" fullWidth={true} formClassName={classes.last_three_input}/> 
          
          <NumberInput source="approvedConveyance" label="Approved Conveyance" fullWidth={true} formClassName={classes.one_three_input}/> 
          <TextInput source="conveyanceDetails"  label="Conveyance Details" fullWidth={true} formClassName={classes.two_three_input}/>
          <DateInput label="Paid On" source="paidOn" fullWidth={true} formClassName={classes.last_three_input} />

          <TextInput source="remarks"   multiline={true} label="Remarks" fullWidth={true} />
          {/* <ReferenceInput label="Executive" source="employeeId" reference="employees" formClassName={classes.one_three_input}
            sort={{ field: 'name', order: 'ASC' }}
            >
              <SelectInput optionText="name" validate={[required()]}  formClassName={classes.one_three_input} />
          </ReferenceInput> */}
          <ReferenceInput perPage={2500} label="Executive" source="employeeId" reference="employees"  formClassName={classes.one_three_input}
            sort={{ field: 'name', order: 'ASC' }}
            >
                        <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} formClassName={classes.one_three_input}/>
          </ReferenceInput>
        
          <BooleanInput validate={[required()]} source="isActive" label=" Active ?" formClassName={classes.two_three_input} /> 
          
          
      </SimpleForm>
    </Create>
  );
};
